// extracted by mini-css-extract-plugin
module.exports = {"component":"selected-passengers_component__zYpJF","userAvatar":"selected-passengers_userAvatar__ulKKY"};